module.exports = __webpack_public_path__ + "static/media/love.c595ed2a.svg";